import {
  AiFillHeart,
  AiFillLock,
  AiFillSignal,
  AiFillStar,
  AiOutlineAppstore,
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineGif,
  AiOutlineHeart,
  AiOutlineHistory,
  AiOutlineInfo,
  AiOutlineLineChart,
  AiOutlineLink,
  AiOutlineLogout,
  AiOutlineUnorderedList,
  AiOutlineMenuFold,
  AiOutlinePicture,
  AiOutlinePercentage,
  AiOutlineQrcode,
  AiOutlineRetweet,
  AiOutlineSend,
  AiOutlineStar,
  AiOutlineSwap,
  AiOutlineTeam,
  AiOutlineCamera,
} from 'react-icons/ai'
import {
  BiDollarCircle,
  BiArrowBack,
  BiCopy,
  BiLinkExternal,
  BiMessageRounded,
  BiSelectMultiple,
  BiUndo,
  BiCoin,
  BiGift,
} from 'react-icons/bi'
import {
  BsCurrencyDollar,
  BsDiscord,
  BsEmojiSmile,
  BsMedium,
  BsQuestion,
  BsQuestionCircle,
  BsPersonBoundingBox,
  BsSearch,
  BsTelegram,
  BsTwitter,
  BsTrash,
  BsExclamationCircle,
  BsYoutube,
  BsFolderSymlink,
} from 'react-icons/bs'
import { CgMenu, CgArrowsExchangeAltV, CgEye } from 'react-icons/cg'
import {
  FaChartArea,
  FaChartPie,
  FaFire,
  FaGasPump,
  FaSortDown,
  FaSortUp,
  FaWifi,
  FaArrowDown,
  FaRegCommentDots,
  FaUserAstronaut,
} from 'react-icons/fa'
import {
  FiAlertCircle,
  FiCheck,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiEdit,
  FiMinusCircle,
  FiPlus,
  FiPlusCircle,
  FiX,
} from 'react-icons/fi'
import { GoBook, GoGear } from 'react-icons/go'
import {
  HiOutlineCog,
  HiOutlineChartPie,
  HiOutlineDocumentText,
  HiServer,
  HiOutlineUserGroup,
} from 'react-icons/hi'
import { HiTv } from 'react-icons/hi2'
import { MdLiveTv } from 'react-icons/md'
import { ImBlocked } from 'react-icons/im'
import { Video } from 'lucide-react'
import {
  IoCheckmarkCircleOutline,
  IoCloseCircleOutline,
  IoWalletOutline,
  IoLanguage,
  IoCart,
} from 'react-icons/io5'
import {
  MdAreaChart,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdLanguage,
  MdOutlineLockOpen,
  MdSpaceBar,
  MdOutlineHdrAuto,
  MdVerified,
  MdDelete,
} from 'react-icons/md'
import { RiShareBoxLine } from 'react-icons/ri'
import {
  SlBell,
  SlBubbles,
  SlEnvolope,
  SlGameController,
  SlGlobeAlt,
  SlHandbag,
  SlHome,
  SlLock,
  SlPeople,
  SlSettings,
  SlTrophy,
  SlUser,
} from 'react-icons/sl'
import { TbTournament } from 'react-icons/tb'
import {
  VscAdd,
  VscCalendar,
  VscCloudUpload,
  VscError,
  VscInfo,
  VscKey,
  VscLock,
  VscSignOut,
  VscSymbolMethod,
  VscLoading,
  VscGraph,
  VscGlobe,
  VscWand,
} from 'react-icons/vsc'
import { FaRetweet } from 'react-icons/fa6'
const Icons = {
  account: SlUser,
  accountCircle: BsPersonBoundingBox,
  add: VscAdd,
  alias: FaUserAstronaut,
  arrowBack: BiArrowBack,
  arrowDown: FaArrowDown,
  arrowDownLine: MdKeyboardArrowDown,
  arrowLeft: AiOutlineArrowLeft,
  arrowRight: AiOutlineArrowRight,
  arrowUp: MdKeyboardArrowUp,
  arrowUpLine: MdKeyboardArrowUp,
  auto: MdOutlineHdrAuto,
  backup: VscCloudUpload,
  barchart: AiFillSignal,
  bell: SlBell,
  blocked: ImBlocked,
  calendar: VscCalendar,
  camera: AiOutlineCamera,
  cart: IoCart,
  chart: AiOutlineLineChart,
  chartArea2: FaChartArea,
  chartArea: MdAreaChart,
  chartPie: FaChartPie,
  chartPieOutline: HiOutlineChartPie,
  check: FiCheck,
  checkmark: FiCheck,
  chevronDown: FiChevronDown,
  chevronLeft: FiChevronLeft,
  chevronRight: FiChevronRight,
  chevronUp: FiChevronUp,
  close: FiX,
  cog: HiOutlineCog,
  copy: BiCopy,
  currencyDollar: BsCurrencyDollar,
  disconnect: VscSignOut,
  discord: BsDiscord,
  docs: GoBook,
  dollarOutlined: BiDollarCircle,
  edit: FiEdit,
  delete: MdDelete,
  email: SlEnvolope,
  exchange: CgArrowsExchangeAltV,
  explore: SlGlobeAlt,
  external: BiLinkExternal,
  eye: CgEye,
  feedback: FaRegCommentDots,
  fire: FaFire,
  forum: SlBubbles,
  game: SlGameController,
  gas: FaGasPump,
  gif: AiOutlineGif,
  globe: VscGlobe,
  graph: VscGraph,
  grid: AiOutlineAppstore,
  heart: AiOutlineHeart,
  heartFilled: AiFillHeart,
  history: AiOutlineHistory,
  home: SlHome,
  image: AiOutlinePicture,
  import: BsFolderSymlink,
  info: AiOutlineInfo,
  infoCircle: VscInfo,
  invalid: IoCloseCircleOutline,
  key: VscKey,
  language: MdLanguage,
  languageLetters: IoLanguage,
  league: SlTrophy,
  link: AiOutlineLink,
  list: AiOutlineUnorderedList,
  loader: VscLoading,
  lock: VscLock,
  lockFill: AiFillLock,
  logout: AiOutlineLogout,
  medium: BsMedium,
  menu: CgMenu,
  menuFold: AiOutlineMenuFold,
  minusCircle: FiMinusCircle,
  multiSettings: GoGear,
  node: VscSymbolMethod,
  password: SlLock,
  people: SlPeople,
  percent: AiOutlinePercentage,
  plus: FiPlus,
  plusCircle: FiPlusCircle,
  qrcode: AiOutlineQrcode,
  question: BsQuestion,
  questionCircle: BsQuestionCircle,
  reply: BiMessageRounded,
  retweet: AiOutlineRetweet,
  retweetFilled: FaRetweet,
  revert: BiUndo,
  search: BsSearch,
  selectAll: BiSelectMultiple,
  send: AiOutlineSend,
  server: HiServer,
  settings: SlSettings,
  share: RiShareBoxLine,
  shout: VscWand,
  smile: BsEmojiSmile,
  sortDown: FaSortDown,
  sortUp: FaSortUp,
  spaceBar: MdSpaceBar,
  starEmpty: AiOutlineStar,
  starFilled: AiFillStar,
  store: SlHandbag,
  switch: AiOutlineSwap,
  team: AiOutlineTeam,
  telegram: BsTelegram,
  tournament: TbTournament,
  trash: BsTrash,
  tv: HiTv,
  twitter: BsTwitter,
  unlock: MdOutlineLockOpen,
  valid: IoCheckmarkCircleOutline,
  verified: MdVerified,
  wallet: IoWalletOutline,
  warn: BsExclamationCircle,
  warning: BsExclamationCircle,
  alertCircle: FiAlertCircle,
  trophy: SlTrophy,
  users: HiOutlineUserGroup,
  gamepad2: SlGameController,
  spinner: VscLoading,
  wifi: FaWifi,
  xCircle: VscError,
  youtube: BsYoutube,
  documentation: HiOutlineDocumentText,
  group: HiOutlineUserGroup,
  video: Video,
  videoCamera: Video,
  coin: BiCoin,
  gift: BiGift,
  tip: BiCoin,
} as const

export default Icons
